<template>
	<v-dialog
			v-model="$store.state.point.showInputVoucherCodeDialog"
			max-width="600px"
			persistent>
		<v-card class="customVCard">
			<v-card-title>
				Kode Voucher
			</v-card-title>
			<template v-if="!isEmpty(errorMessage_)">
				<v-card-text>
					<span class="body-1" style="color:red" v-text="errorMessage_" />
				</v-card-text>
			</template>
			<template v-if="mode_.enter">
				<v-card-text>
					<v-form	ref="formVoucherCode"
							lazy-validation>
						<v-text-field
								v-model="voucherCode_"
								label="Masukan Kode Voucher" />
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-row dense justify="center">
						<v-col cols="auto">
							<v-btn	class="customVBtn"
									color="error"
									dark
									depressed
									large
									@click="$_pntInptVchrCdDlg_input()">
								<template v-if="isFalse(onProgress_)">
									Masuk
								</template>
								<template v-else>
									<progress-circular />
								</template>
							</v-btn>
						</v-col>
						<v-col cols="auto">
							<v-btn	class="customVBtn"
									color="secondary"
									dark
									depressed
									large
									@click="$_pntInptVchrCdDlg_close()">
								Tutup
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</template>
			<template v-if="mode_.complete">
				<v-card-text>
					<span class="body-1">Selamat!</span>
				</v-card-text>
				<v-card-actions>
					<v-row dense justify="center">
						<v-col cols="auto">
							<v-btn	class="customVBtn"
									color="secondary"
									dark
									depressed
									large
									@click="$_pntInptVchrCdDlg_close()">
								OK
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</template>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'PointInputVoucherCodeDialog',
		data() {
			return {
				show_: false,

				valid_: true,

				mode_: {
					enter: true,
					complete: false
				},

				voucherCode_: null,
				voucher_: {},
				
				errorMessage_: null,
				onProgress_: false
			}
		},
		computed: {
			// current user
			$_pntInptVchrCdDlg_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			}
		},
		methods: {
			$_pntInptVchrCdDlg_input() {
				const self_ = this;

				self_.onProgress_ = true;

				Promise.resolve().then(() => {
					return self_.$_pntInptVchrCdDlg_checkVoucherCode()
				}).then(() => {
					return self_.$_pntInptVchrCdDlg_updateVoucherCode()
				}).then(() => {
					return self_.$_pntInptVchrCdDlg_givePoint()
				}).then(() => {
					self_.errorMessage_ = null;
					self_.onProgress_ = false;

					self_.mode_ = { complete: true }
				}).catch(error => {
					self_.errorMessage_ = error;
					self_.onProgress_ = false;

/* error */			self_.logError('error', '$_pntInptVchrCdDlg_input()', error)
				})
			},
			$_pntInptVchrCdDlg_checkVoucherCode() {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getVoucher(self_.voucherCode_)
					}).then(result => {
						if(self_.isEmpty(result)) { reject('Kode voucher tidak cocok.') }
						else {
							if(result.status == 'used') { reject('Kode voucher sudah dipakai.') }
							else if(result.status == 'inactive') { reject('Kode voucher tidak aktif.') }
							else {
								self_.voucher_ = result;
								resolve()
							}
						}
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_pntInptVchrCdDlg_updateVoucherCode() {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						self_.voucher_.status = 'used';
						return self_.setVoucher(self_.voucherCode_, self_.voucher_.name, self_.voucher_.point, self_.voucher_.startDate, self_.voucher_.endDate, self_.voucher_.criteriumCode, self_.voucher_.criteriumName, self_.voucher_.status)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_pntInptVchrCdDlg_givePoint() {
				const self_ = this;

				const clientUserId_ = self_.getUserState('oldSystemClientUserId')
				const group_ = 'user';

				const criterium_ = self_.voucher_.criteriumCode;
				const promocode_ = self_.voucherCode_;
				const point_ = self_.voucher_.point;
				const startDate_ = self_.formatTimestamp(self_.voucher_.startDate, 'YYYY-MM-DD')
				const endDate_ = self_.formatTimestamp(self_.voucher_.endDate, 'YYYY-MM-DD')
				// store point giving
				return self_.ipcStorePointGiving(clientUserId_, group_, criterium_, promocode_, point_, startDate_, endDate_)
			},
			$_pntInptVchrCdDlg_close() {
				const self_ = this;
				const router_ = self_.$router;

				self_.mode_ = { enter: true }
				
				self_.voucherCode_ = null;
				self_.voucher_ = {};

				self_.errorMessage_ = null;
				self_.point_ = null;

				self_.setPointState('showInputVoucherCodeDialog', false)

				self_.openLink({ method: { name: 'reload' }})
			}
		}
	}
</script>

<style scoped>
</style>
